module.exports = __webpack_public_path__ + "img/briefcase-clock-outline.c7e48712.svg";